import { useRouter } from 'vue-router';
import { useCustomToast } from '@/shared/lib';
import { useMatrixPageOrigin } from './useMatrixPageOrigin';

export const VIEW_RECORD_ROUTE_NAME = 'VisualizarRegistro';
export const LINK_COPIED_TITLE = 'Link copiado.';
export const LINK_COPY_FAILED_TITLE = 'Não foi possível copiar o link.';

export function useGeneratedRecordLink() {
  const router = useRouter();
  const { prefix, returnQuery } = useMatrixPageOrigin();
  const { showSuccessToast, showErrorToast } = useCustomToast();

  function viewLocation(recordId: number) {
    return {
      name: VIEW_RECORD_ROUTE_NAME,
      params: { prefix: prefix(), recordId: String(recordId) },
    };
  }

  // Read only: no open, so viewing never turns the record "Em uso".
  async function viewGeneratedRecord(recordId: number): Promise<void> {
    await router.push({ ...viewLocation(recordId), ...returnQuery() });
  }

  // The link leaves the revision folder out: whoever opens it may not see that folder, and without
  // it the way back is the code's matrix page.
  async function copyGeneratedRecordLink(recordId: number): Promise<void> {
    const url = `${globalThis.location.origin}${router.resolve(viewLocation(recordId)).href}`;
    try {
      await navigator.clipboard.writeText(url);
      showSuccessToast({ title: LINK_COPIED_TITLE, type: 'success' });
    } catch {
      showErrorToast({ title: LINK_COPY_FAILED_TITLE, type: 'error' });
    }
  }

  return { viewGeneratedRecord, copyGeneratedRecordLink };
}
